/* Claude Flow — Engine für die selbst gebauten Lead-Flows (Ersatz für Heyflow).
   Eine Datei für alle Flows; der Inhalt steckt jeweils im Snippet.

   Wurzelelement:
     <div class="cflow"
          data-cf-flow="katze"                  interner Schlüssel
          data-cf-flowname="Katzenversicherung" lesbarer Name fürs CRM
          data-cf-event="Claude_Lead_Katze"     GA4/GTM-Event beim Absenden
          data-cf-webhook="https://hook…">      Make-Webhook

   Screen:
     <div class="cf-screen" data-cf-screen="S3" data-cf-name="alter">
     optional automatisch weiter: data-cf-weiter="S4" data-cf-wartezeit="1800"

   Auswahlfrage:
     <div class="cf-kacheln" data-cf-var="Alter" data-cf-label="Wie alt ist Ihre Katze?">
       <button data-cf-antwort="0 bis 3 Jahre" data-cf-ziel="S4">…</button>

   Eingabefeld:
     <div class="cf-feld" data-cf-feld data-cf-typ="text|tel|email|checkbox"
          data-cf-var="Name-HF" data-cf-label="Lead Name">

   Buttons:
     data-cf-btn="weiter"   validiert die Felder des Screens, dann data-cf-ziel
     data-cf-btn="absenden" validiert, sendet an den Webhook, dann data-cf-ziel
     data-cf-btn="zurueck"  einen Schritt zurück
*/
(function () {
  "use strict";

  function init(wurzel) {
    if (wurzel.dataset.cfBereit === "1") return;
    wurzel.dataset.cfBereit = "1";

    var KONF = {
      flow: wurzel.dataset.cfFlow || "",
      flowName: wurzel.dataset.cfFlowname || wurzel.dataset.cfFlow || "",
      event: wurzel.dataset.cfEvent || "",
      webhook: wurzel.dataset.cfWebhook || ""
    };

    var antworten = {};
    var verlauf = [];
    var screens = wurzel.querySelectorAll(".cf-screen");
    var gestartet = false;

    // Erste Interaktion mit dem Flow einmalig als Start-Event melden —
    // zusammen mit dem Absende-Event ergibt das die Abschlussquote je Flow.
    function meldeStart() {
      if (gestartet) return;
      gestartet = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Claude_Flow_Start_" + KONF.flow,
        flow: KONF.flow
      });
    }
    wurzel.addEventListener("click", function (e) {
      if (e.target.closest("[data-cf-antwort],[data-cf-btn]")) meldeStart();
    });
    wurzel.addEventListener("input", meldeStart, { once: true });

    // Datum und Uhrzeit immer in deutscher Zeit — unabhängig davon,
    // in welcher Zeitzone der Besucher unterwegs ist.
    function deutscheZeit() {
      var jetzt = new Date();
      try {
        return {
          datum: new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin",
            day: "2-digit", month: "2-digit", year: "numeric" }).format(jetzt),
          uhrzeit: new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin",
            hour: "2-digit", minute: "2-digit", hour12: false }).format(jetzt)
        };
      } catch (e) {
        return { datum: "", uhrzeit: "" };
      }
    }

    // Telefonnummer in eine saubere internationale Form bringen.
    // Verhindert Dopplungen wie "+49 +4917612345678".
    function telNormalisieren(vorwahl, eingabe) {
      var n = String(eingabe || "").replace(/[^\d+]/g, "");
      if (n.indexOf("00") === 0) n = "+" + n.slice(2);
      if (n.charAt(0) === "+") return n;
      if (n.charAt(0) === "0") return (vorwahl || "+49") + n.slice(1);
      return (vorwahl || "+49") + n;
    }

    function aktuellerScreen() {
      var a = wurzel.querySelector(".cf-screen.cf-aktiv");
      return a ? a.dataset.cfScreen : null;
    }

    function zeige(id, merken) {
      var jetzige = aktuellerScreen();
      if (merken !== false && jetzige && jetzige !== id) verlauf.push(jetzige);

      for (var i = 0; i < screens.length; i++) {
        if (screens[i].dataset.cfScreen === id) screens[i].classList.add("cf-aktiv");
        else screens[i].classList.remove("cf-aktiv");
      }

      // sanft nach oben, aber nur wenn das Formular aus dem Bild gerutscht ist
      var box = wurzel.getBoundingClientRect();
      if (box.top < 0) {
        window.scrollTo({ top: window.pageYOffset + box.top - 20, behavior: "smooth" });
      }

      var neuer = wurzel.querySelector('[data-cf-screen="' + id + '"]');
      if (!neuer) return;

      // Platzhalter mit dem Vornamen füllen
      var platzhalter = neuer.querySelectorAll("[data-cf-name-einsetzen]");
      for (var p = 0; p < platzhalter.length; p++) {
        var vorname = antworten["__vorname"];
        platzhalter[p].textContent = (vorname ? vorname + " – " : "") +
          platzhalter[p].dataset.cfNameEinsetzen;
      }

      // Screens, die von selbst weiterspringen (Ladeanimation)
      if (neuer.dataset.cfWeiter) {
        window.setTimeout(function () {
          zeige(neuer.dataset.cfWeiter, false);
        }, parseInt(neuer.dataset.cfWartezeit || "1800", 10));
      }
    }

    function markiere(el, fehlerhaft) {
      if (!el) return;
      if (fehlerhaft) el.classList.add("cf-fehler");
      else el.classList.remove("cf-fehler");
    }

    // Alle Felder eines Screens prüfen und übernehmen.
    // Gibt true zurück, wenn alles in Ordnung ist.
    function felderPruefen(screen) {
      var felder = screen.querySelectorAll("[data-cf-feld]");
      var okay = true;
      var zwischen = {};

      for (var i = 0; i < felder.length; i++) {
        var feld = felder[i];
        var typ = feld.dataset.cfTyp || "text";
        var input = feld.querySelector("input, textarea, select:not([data-cf-vorwahl])");
        if (!input) continue;

        var wert = "";
        var gut = true;

        if (typ === "checkbox") {
          gut = !!input.checked;
          wert = gut ? "Ja" : "";
        } else if (typ === "tel") {
          var roh = String(input.value || "");
          gut = roh.replace(/[^0-9]/g, "").length >= 6;
          var vorwahlFeld = feld.querySelector("[data-cf-vorwahl]");
          wert = gut ? telNormalisieren(vorwahlFeld ? vorwahlFeld.value : "+49", roh) : "";
        } else if (typ === "email") {
          wert = String(input.value || "").trim();
          gut = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert);
        } else {
          wert = String(input.value || "").trim();
          gut = wert.length > 0;
        }

        markiere(feld, !gut);
        if (!gut) {
          if (okay && input.focus) input.focus();
          okay = false;
          continue;
        }

        if (feld.dataset.cfVar) {
          zwischen[feld.dataset.cfVar] = { label: feld.dataset.cfLabel || "", wert: wert };
        }
        if (feld.dataset.cfVorname === "1") zwischen.__vorname = wert;
      }

      if (okay) {
        Object.keys(zwischen).forEach(function (k) { antworten[k] = zwischen[k]; });
      }
      return okay;
    }

    // Auswahl-Kacheln
    var knoepfe = wurzel.querySelectorAll("[data-cf-antwort][data-cf-ziel]");
    for (var i = 0; i < knoepfe.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          var gruppe = btn.closest("[data-cf-var]");
          if (!gruppe) {
            var screen = btn.closest(".cf-screen");
            gruppe = screen ? screen.querySelector("[data-cf-var]") : null;
          }
          if (gruppe && gruppe.dataset.cfVar) {
            antworten[gruppe.dataset.cfVar] = {
              label: gruppe.dataset.cfLabel || "",
              wert: btn.dataset.cfAntwort
            };
          }
          zeige(btn.dataset.cfZiel);
        });
      })(knoepfe[i]);
    }

    // Weiter-Buttons
    var weiterKnoepfe = wurzel.querySelectorAll('[data-cf-btn="weiter"]');
    for (var wI = 0; wI < weiterKnoepfe.length; wI++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          var screen = btn.closest(".cf-screen");
          if (!felderPruefen(screen)) return;
          zeige(btn.dataset.cfZiel);
        });
      })(weiterKnoepfe[wI]);
    }

    // Zurück-Buttons
    var zurueckKnoepfe = wurzel.querySelectorAll('[data-cf-btn="zurueck"]');
    for (var zI = 0; zI < zurueckKnoepfe.length; zI++) {
      zurueckKnoepfe[zI].addEventListener("click", function () {
        if (!verlauf.length) return;
        zeige(verlauf.pop(), false);
      });
    }

    // Absenden
    var sendeKnoepfe = wurzel.querySelectorAll('[data-cf-btn="absenden"]');
    for (var sI = 0; sI < sendeKnoepfe.length; sI++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          var screen = btn.closest(".cf-screen");
          if (!felderPruefen(screen)) return;

          var zeit = deutscheZeit();
          var payload = {
            flow: KONF.flow,
            flow_name: KONF.flowName,
            datum: zeit.datum,
            uhrzeit: zeit.uhrzeit
          };
          Object.keys(antworten).forEach(function (k) {
            if (k.indexOf("__") === 0) return;
            payload[k] = antworten[k].wert;
          });

          // Genau ein Tracking-Event, wie abgestimmt
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: KONF.event, flow: KONF.flow });

          btn.setAttribute("disabled", "disabled");
          var weiter = function () { zeige(btn.dataset.cfZiel); };

          if (!KONF.webhook) { weiter(); return; }

          fetch(KONF.webhook, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          }).then(weiter).catch(function () {
            btn.removeAttribute("disabled");
            window.alert("Leider hat das nicht geklappt. Bitte versuchen Sie es erneut.");
          });
        });
      })(sendeKnoepfe[sI]);
    }

    // Auf dem Handy lange Aufklapplisten eingeklappt starten
    if (window.matchMedia && window.matchMedia("(max-width:749px)").matches) {
      var details = wurzel.querySelectorAll("details.cf-spalte");
      for (var d = 0; d < details.length; d++) details[d].open = false;
    }
  }

  function alleStarten() {
    var wurzeln = document.querySelectorAll(".cflow");
    for (var i = 0; i < wurzeln.length; i++) init(wurzeln[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", alleStarten);
  } else {
    alleStarten();
  }
  document.addEventListener("shopify:section:load", alleStarten);
})();
